'use client';

import { useTranslation } from 'next-i18next';
import { LinkStyled } from '@components/common/Anchor/LinkStyled';
import { useCoachingGreeting } from '@hooks/features/useCoachingGreeting';

/**
 * Empty-state landing for the candidate coaching (bestie-chat) view.
 * Shows a single personalised coaching greeting — title + description — in place of the
 * job-search landing's rotating greeting and recommended jobs. Decorative only; the user
 * starts the conversation from the CandidatePromptBar below this component.
 */
export const CoachingLanding = () => {
  const { t } = useTranslation('common');
  const { title, description } = useCoachingGreeting();

  return (
    <div className="flex grow flex-col items-center justify-end px-4 pb-16 pt-8 md:pb-12">
      <div className="flex w-full max-w-4xl flex-col items-center gap-4 text-center">
        <span className="min-h-[1.375em] w-full text-balance text-3xl font-bold leading-snug sm:text-4xl lg:text-[56px] lg:leading-tight">
          {title}
        </span>

        {description && (
          <p className="max-w-3xl text-balance text-base text-ink-medium md:text-lg">
            {description}
          </p>
        )}

        <LinkStyled href="/mc/my-bestie" styling="none" className="mt-6 text-center underline underline-offset-4">
          {t('my.bestie.home.cta.short')}
        </LinkStyled>
      </div>
    </div>
  );
};
